import React, { useEffect, useState } from "react";
import Modal from 'react-modal';
import BannerInfoMan from './images/banner-video/infoman-video-banner.png';
import BannerRWB from './images/banner-video/rwb-video-banner.png'
import BannerMemoires from './images/banner-video/memoires-video-banner.png';
import BannerDTUnion from './images/banner-video/dtunion-video-banner.png'
import BannerAmicale from './images/banner-video/amicale-video-banner.png';
import BannerAutresVoix2010 from './images/banner-video/franciska-video-banner.png';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import Menu from "./Menu";

import './ProjetTest.css';

const VoixAssociations = () =>{
    



     const [videoPlay, setVideoPaly] = useState (false);  

        const [videoQuiz, setVideoLeQuiz] = useState(false);
        const [videoInfoMan, setVideoInfoMan] = useState(false);
        const [videoRWB, setVideoRWB] = useState(false);
        const [videoMemoires, setVideoMemoires] = useState(false);
        const [videoDTUnion, setVideoDTUnion] = useState(false);
        const [videoAmicale, setVideoAmicale] = useState(false);
        const [videoRadioAra, setVideoRadioAra] = useState(false);
 
       
        const handleInfoMann = () =>{
            setVideoInfoMan(true);
    
            
    
        }
        const handleRWB = () =>{
            setVideoRWB(true);
    
            
    
        }
        const handleMemoires = () =>{
            setVideoMemoires(true);
        }
        const handleDTUnion = () =>{
            setVideoDTUnion(true);
        }
        const handleAmicale = () =>{
            setVideoAmicale(true);
        }
        const handleRadioAra = () =>{
            setVideoRadioAra(true);
        }
        const handleVideoQuiz = () =>{
            setVideoLeQuiz(true);
    
        }
       
  
        const handleClose = () =>{
         
            setVideoAmicale(false);
            setVideoDTUnion(false);
            setVideoInfoMan(false);
            setVideoMemoires(false);
            setVideoRWB(false);
            setVideoRadioAra(false);
         
        
        }
     
     
     
      
    
    
 

        
    

    return(
        <>
        <Menu></Menu>
<div className="envelope-projeto">
    
    
    {/* <div className="projeto-banner">
    <div className="description-title">
    
    </div>
    </div> */}
        <div className="banner-projeto">
            <div className="poster_onglet">
              
                </div>
                <div className="poster_onglet_700">
              
              </div>
        </div>
        
        <div className="grid-container-projeto container-projet">

           

           <div className="grid-item-projeto grid-video" id="grid1-projeto">
                       <div className="image-container-carte" onClick={handleInfoMann}>
                           <img src={BannerInfoMan}></img>
           {/*             <iframe width="100%" height="315" src="https://www.youtube.com/embed/-39SsPD1BOo?si=zKIM6oD3olx8QDF0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            */}            </div>
                    {/*    <a href="https://youtu.be/-39SsPD1BOo?si=RopOZ1MBPPJEysbI">
           
                       <div className="container-projeto-button">
                           <button className="projeto-button">InfoMan</button>
           
                           
           
                       </div> 
                       </a> */}
                       <div className="container-projeto-button">
                           
                           <button className="projeto-button" onClick={handleInfoMann}>InfoMann</button>
           
                           
           
                       </div> 
                       <Modal 
                           className="modal-content-video" 
                           isOpen={videoInfoMan}
                           onRequestClose = {()=> setVideoInfoMan(false)}
                           overlayClassName="modal-overlay"
                           ariaHideApp={false}
                           
                       >
                           <div className='close-modal-home'>
                               <FontAwesomeIcon icon={faClose} className="icon-close" onClick={handleClose} />
                           </div>
                           <div className="title-video"><h2>InfoMann</h2></div>
                                               
                           <div>
                           <iframe width="560" height="315" src="https://www.youtube.com/embed/-39SsPD1BOo?si=-YD98IROTRDNGbH-" 
                           allowFullScreen></iframe>                </div>
           
                       </Modal> 
                   </div>    
           
           
                   <div className="grid-item-projeto grid-video" id="grid2-projeto">
                       <div className="image-container-carte" onClick={handleRWB}>
                           
                           <img src={BannerRWB}></img>
                           
           {/*             <iframe width="100%" height="315" src="https://www.youtube.com/embed/CBIkxI6vWrA?si=09XLdlpHA1MT3RZb" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            */}
           
                       </div>
                     {/*   <a href="https://youtu.be/CBIkxI6vWrA?si=GS6Tk3KQZnQqAJ46">
           
                       <div className="container-projeto-button">
                           <button className="projeto-button" > RWB
                           </button>
                          
           
                       </div>
                       </a> */}
                       <div className="container-projeto-button">
                           <button className="projeto-button" onClick={handleRWB}>Danzsportclub Rout-Wäiss-Blo Lëtzebuerg
                           </button>
                          
           
                       </div>
                       <Modal 
                           className="modal-content-video" 
                           isOpen={videoRWB}
                           onRequestClose = {()=> setVideoRWB(false)}
                           overlayClassName="modal-overlay"
                           ariaHideApp={false}
                           
                       >
                           <div className='close-modal-home'>
                               <FontAwesomeIcon icon={faClose} className="icon-close" onClick={handleClose} />
                           </div>
                           <div className="title-video"><h2>Danzsportclub Rout-Wäiss-Blo Lëtzebuerg</h2></div>
                                               
                           <div>
                           <iframe width="560" height="315" src="https://www.youtube.com/embed/CBIkxI6vWrA?si=pQAmtPPU-qt9aYdL" 
                            allowFullScreen></iframe>                </div>
           
                       </Modal>
                        
                      {/*  <Modal 
                           className="modal-content-video" 
                           isOpen={videoPlay}
                           onRequestClose = {()=> setVideoPaly(false)}
                           overlayClassName="modal-overlay"
                           ariaHideApp={false}
                           
                       >
                           <div className='close-modal-home'>
                               <FontAwesomeIcon icon={faClose} className="icon-close" onClick={handleClose} />
                           </div>
                           <div><h2>Le projeto En bonne entente</h2></div>
                                               
                           <div>
                               <iframe width="560" height="315" src="https://www.youtube.com/embed/nGdFhr33rh0?si=obCqU53WHQwj8acy" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                           </div>
           
                       </Modal> */}
           
                   </div>
                   <div className="grid-item-projeto grid-video" id="grid3-projeto">
                       <div className="image-container-carte" onClick={handleMemoires}>
                       <img src={BannerMemoires}></img>
           
           {/*             <iframe width="100%" height="315" src="https://www.youtube.com/embed/SqScJMdoeG0?si=2zCUP7Z9e-ySE4I_" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            */}
                       </div>
                   {/*    <a href="https://www.youtube.com/watch?v=SqScJMdoeG0">
                       <div className="container-projeto-button">
                           <button className="projeto-button">Mémoires en voyage
                           </button>
           
                       </div>
                       </a> */}
                       <div className="container-projeto-button">
                           <button className="projeto-button" onClick={handleMemoires}>Mémoires en voyage
                           </button>
           
                       </div>
                       <Modal 
                           className="modal-content-video" 
                           isOpen={videoMemoires}
                           onRequestClose = {()=> setVideoMemoires(false)}
                           overlayClassName="modal-overlay"
                           ariaHideApp={false}
                           
                       >
                           <div className='close-modal-home'>
                               <FontAwesomeIcon icon={faClose} className="icon-close" onClick={handleClose} />
                           </div>
                           <div className="title-video"><h2>Mémoires en voyage</h2></div>
                                               
                           <div>
                           <iframe width="560" height="315" src="https://www.youtube.com/embed/SqScJMdoeG0?si=a0eX0L3tBBFwpFe7"
                            allowFullScreen></iframe>                       </div>
           
                       </Modal>
           
                   </div>
                   <div className="grid-item-projeto grid-video" id="grid4-projeto">
                       <div className="image-container-carte" onClick={handleDTUnion}>
                           <img src={BannerDTUnion}></img>
           {/*             <iframe width="100%" height="315" src="https://www.youtube.com/embed/hTbYa9SJHAE?si=hYEb--Ts-D6LdyYb" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            */}
                       </div>
                     {/*   <a href="https://www.youtube.com/watch?v=hTbYa9SJHAE">
                        <div className="container-projeto-button">
                           <button className="projeto-button" >DT Union
                           </button>
           
                       </div> 
                       </a> */}
                       <div className="container-projeto-button">
                           <button className="projeto-button" onClick={handleDTUnion} >Dësch-Tennis UNION Lëtzebuerg
                           </button>
           
                       </div> 
                       <Modal 
                           className="modal-content-video" 
                           isOpen={videoDTUnion}
                           onRequestClose = {()=> setVideoDTUnion(false)}
                           overlayClassName="modal-overlay"
                           ariaHideApp={false}
                           
                       >
                           <div className='close-modal-home'>
                               <FontAwesomeIcon icon={faClose} className="icon-close" onClick={handleClose} />
                           </div>
                           <div className="title-video"><h2>Dësch-Tennis UNION Lëtzebuerg                </h2></div>
                                               
                           <div>
                           <iframe width="560" height="315" src="https://www.youtube.com/embed/hTbYa9SJHAE?si=lCTVqz2WAIZ9KRx3" 
                            allowFullScreen></iframe>
                        </div>
           
                       </Modal>
                   </div>
                   <div className="grid-item-projeto grid-video" id="grid5-projeto">
                       <div className="image-container-carte" onClick={handleAmicale}>
                           <img src={BannerAmicale}></img>
           {/*             <iframe width="100%" height="315" src="https://www.youtube.com/embed/HLZRqDpd2m4?si=8Ln9FTBoQ3SJVLWu" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            */}
                       </div>
                      {/*  <a href="https://www.youtube.com/watch?v=HLZRqDpd2m4">
                      <div className="container-projeto-button">
                           <button className="projeto-button"> Amicale des Français à Luxembourg
                           </button>
           
                       </div>
                       </a> */}
                       <div className="container-projeto-button">
                           <button className="projeto-button" onClick={handleAmicale}> Amicale des Français à Luxembourg
                           </button>
           
                       </div>
                       <Modal 
                           className="modal-content-video" 
                           isOpen={videoAmicale}
                           onRequestClose = {()=> setVideoAmicale(false)}
                           overlayClassName="modal-overlay"
                           ariaHideApp={false}
                           
                       >
                           <div className='close-modal-home'>
                               <FontAwesomeIcon icon={faClose} className="icon-close" onClick={handleClose} />
                           </div>
                           <div className="title-video"><h2>Amicale des Français à Luxembourg</h2></div>
                                               
                           <div>
                           <iframe width="560" height="315" src="https://www.youtube.com/embed/HLZRqDpd2m4?si=PiaLoCbUHUH1hMT8" 
                            allowFullScreen></iframe>                </div>
           
                       </Modal>
           
                   </div>  
                   <div className="grid-item-projeto grid-video" id="grid3-projeto">
                       <div className="image-container-carte" onClick={handleRadioAra}>
                           <img src={BannerAutresVoix2010}></img>
           {/*             <iframe width="100%" height="315" src="https://www.youtube.com/embed/SqScJMdoeG0?si=2zCUP7Z9e-ySE4I_" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            */}
                       </div>
                     {/*    <a href="https://www.youtube.com/watch?v=o4YKQ5pHxnA">
                       
                       <div className="container-projeto-button">
                           <button className="projeto-button"> Radio Ara
                           </button>
           
                       </div>
                       </a>  */}
                        
                       <div className="container-projeto-button">
                           <button className="projeto-button" onClick={handleRadioAra}> Radio Ara
                           </button>
           
                       </div>
                       <Modal 
                           className="modal-content-video" 
                           isOpen={videoRadioAra}
                           onRequestClose = {()=> setVideoRadioAra(false)}
                           overlayClassName="modal-overlay"
                           ariaHideApp={false}
                           
                       >
                           <div className='close-modal-home'>
                               <FontAwesomeIcon icon={faClose} className="icon-close" onClick={handleClose} />
                           </div>
                           <div className="title-video"><h2>Radio Ara</h2></div>
                                               
                           <div>
                           <iframe width="560" height="315" src="https://www.youtube.com/embed/o4YKQ5pHxnA?si=EtFilkQu1CBeuaQG"
                           allowFullScreen></iframe>                </div>
           
                       </Modal>
           
                   </div>   
             
                
                    
                     
    
</div>  
</div>

        </>
    );
}

export default VoixAssociations;